import { apiClient } from './client';
import { budgetGoalsResponseSchema, budgetSummarySchema } from './schemas';
import type { BudgetGoal, BudgetGoalsResponse, BudgetSummary } from './types';

export const budgetsApi = {
  async getGoals(): Promise<BudgetGoalsResponse> {
    return apiClient.get<BudgetGoalsResponse>('/budgets/goals', budgetGoalsResponseSchema);
  },

  async updateGoals(goals: BudgetGoal[]): Promise<BudgetGoalsResponse> {
    return apiClient.put<BudgetGoalsResponse>('/budgets/goals', { goals }, budgetGoalsResponseSchema);
  },

  async getSummary(from: string, to: string): Promise<BudgetSummary> {
    return apiClient.get<BudgetSummary>(`/budgets?from=${from}&to=${to}`, budgetSummarySchema);
  },
};
